import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticatedComponent } from 'app/shared/layout/authenticated/authenticated.component';
import { AuthGuard } from 'app/shared/guards/auth.guard';
import { ListCampaignsComponent } from './list-campaigns/list-campaigns.component';
import { EditCampaignComponent } from './edit-campaign/edit-campaign.component';
import { PreviewContentComponent } from './preview-content/preview-content.component';
import { EditTemplateComponent } from './edit-template/edit-template.component';
import { ECampaignCreateState } from 'app/store/models/campaigns.model';
import { CommunicationContentComponent } from './communication-content/communication-content.component';
import { BlockedDatesComponent } from './blocked-dates/blocked-dates.component';

const routes: Routes = [
  {
    path: '',
    component: AuthenticatedComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: ListCampaignsComponent,
      },
      {
        path: 'new',
        canActivate: [AuthGuard],
        component: EditCampaignComponent,
        data: {
          state: ECampaignCreateState.CREATE,
        },
      },
      {
        path: 'block_dates',
        canActivate: [AuthGuard],
        component: BlockedDatesComponent,
      },
      {
        path: ':id/edit',
        canActivate: [AuthGuard],
        component: EditCampaignComponent,
        data: {
          state: ECampaignCreateState.EDIT,
        },
      },
      {
        path: ':id/preview-content',
        canActivate: [AuthGuard],
        component: PreviewContentComponent,
        data: {
          state: ECampaignCreateState.EDIT,
        },
      },
      {
        path: ':id/preview-content/:templateId',
        canActivate: [AuthGuard],
        component: EditTemplateComponent,
        data: {
          state: ECampaignCreateState.EDIT,
        },
      },
      {
        path: ':id/communication-content',
        canActivate: [AuthGuard],
        component: CommunicationContentComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CampaignsRoutingModule {}
